export default {
  type: 'menu',
  code: '12000000',
  addBlockChain: {
    type: 'btns',
    code: '12010000'
  },
  suscribeBlockChain: {
    type: 'btns',
    code: '12020000',
    suscribe: {
      type: 'btns',
      code: '12020100'
    },
    unSuscribe: {
      type: 'btns',
      code: '12020200'
    }
  },
  downloadDeployConfig: {
    type: 'btns',
    code: '12030000'
  },
  checkDetail: {
    type: 'btns',
    code: '12040000',
    overview: {
      type: 'menu',
      code: '12040100',
      authManage: {
        type: 'btns',
        code: '12040101'
      },
      modConfig: {
        type: 'btns',
        code: '12040102'
      }
    },
    contractManage: {
      type: 'menu',
      code: '12040200',
      deployContract: {
        type: 'btns',
        code: '12040201'
      }
    },
    coChainManage: {
      type: 'menu',
      code: '12040300',
      doCoChain: {
        type: 'btns',
        code: '12040301'
      }
    },
    voteManage: {
      type: 'menu',
      code: '12040400',
      check: {
        type: 'btns',
        code: '12040401'
      }
    },
    orgInfo: {
      type: 'menu',
      code: '12040500'
    },
    nodeInfo: {
      type: 'menu',
      code: '12040600',
      check: {
        type: 'btns',
        code: '12040601'
      }
    },
    userManage: {
      type: 'menu',
      code: '12040700',
      create: {
        type: 'btns',
        code: '12040701'
      },
      downloadContract: {
        type: 'btns',
        code: '12040702'
      }
    },
    createOnChainData: {
      type: 'menu',
      code: '12040800',
      create: {
        type: 'btns',
        code: '12040801'
      },
      reset: {
        type: 'btns',
        code: '12040802'
      }
    },
    onChainRetrieval: {
      type: 'menu',
      code: '12040900',
      retrieval: {
        type: 'btns',
        code: '12040901'
      },
      clear: {
        type: 'btns',
        code: '12040902'
      }
    },
    nodeExpansion: {
      type: 'menu',
      code: '12041000',
      create: {
        type: 'btns',
        code: '12041001'
      }
    },
    dataArchiving: {
      type: 'menu',
      code: '12041100',
      create: {
        type: 'btns',
        code: '12041101'
      },
      restore: {
        type: 'btns',
        code: '12041102'
      },
      search: {
        type: 'btns',
        code: '12041103'
      }
    }
  }
}
